import { render, staticRenderFns } from "./CoachingSection.vue?vue&type=template&id=1a1d8893&scoped=true&"
import script from "./CoachingSection.vue?vue&type=script&lang=js&"
export * from "./CoachingSection.vue?vue&type=script&lang=js&"
import style0 from "./CoachingSection.vue?vue&type=style&index=0&id=1a1d8893&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1d8893",
  null
  
)

export default component.exports